import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChildren, input, InputSignal, Signal, TemplateRef, viewChild } from '@angular/core';
import { OgsItemDirective } from '@shared/directives/ogs-item.directive';

@Component({
  selector: 'app-virtual-scroll-wrapper',
  standalone: true,
  imports: [ ScrollingModule, NgTemplateOutlet ],
  templateUrl: './virtual-scroll-wrapper.component.html',
  styleUrl: './virtual-scroll-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VirtualScrollWrapperComponent {
  protected scrollItems: Signal<ReadonlyArray<TemplateRef<unknown>>> = contentChildren(OgsItemDirective, { read: TemplateRef });

  public readonly scrollViewport: Signal<CdkVirtualScrollViewport | undefined> = viewChild(CdkVirtualScrollViewport);

  public itemSize: InputSignal<number> = input.required();

  public minBufferPx: InputSignal<number> = input.required();

  public maxBufferPx: InputSignal<number> = input.required();
}
